import customPopupComponent from './customPopup.component';
import popupModule from '../index';

const customPopupModule = angular.module('app.common.ertCustomPopup', [popupModule])
	.component('ertCustomPopup', customPopupComponent)
	.name;

export default customPopupModule;
